var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:star-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1523 9.82936L16.2765 13.2119L17.4376 18.2478C17.499 18.5111 17.4815 18.7866 17.3872 19.0399C17.2929 19.2933 17.126 19.5132 16.9073 19.6723C16.6887 19.8313 16.4281 19.9223 16.158 19.934C15.8879 19.9457 15.6204 19.8775 15.3888 19.738L10.9965 17.0739L6.61373 19.738C6.38219 19.8775 6.11465 19.9457 5.84457 19.934C5.57448 19.9223 5.31384 19.8313 5.09521 19.6723C4.87659 19.5132 4.70969 19.2933 4.61538 19.0399C4.52108 18.7866 4.50354 18.5111 4.56498 18.2478L5.72428 13.217L1.84764 9.82936C1.6426 9.65252 1.49433 9.41908 1.42144 9.15831C1.34854 8.89755 1.35425 8.62106 1.43786 8.36353C1.52148 8.106 1.67926 7.87889 1.89143 7.71067C2.1036 7.54245 2.36072 7.44063 2.63053 7.41795L7.74037 6.97537L9.73498 2.21788C9.83914 1.96824 10.0148 1.75501 10.2399 1.60502C10.465 1.45503 10.7295 1.375 11 1.375C11.2705 1.375 11.5349 1.45503 11.76 1.60502C11.9851 1.75501 12.1608 1.96824 12.265 2.21788L14.2656 6.97537L19.3737 7.41795C19.6435 7.44063 19.9007 7.54245 20.1128 7.71067C20.325 7.87889 20.4828 8.106 20.5664 8.36353C20.65 8.62106 20.6557 8.89755 20.5828 9.15831C20.5099 9.41908 20.3617 9.65252 20.1566 9.82936H20.1523Z",
    fill: "#FFA800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhStarFill);
export default __webpack_public_path__ + "static/media/ph_star-fill.532694c8ed04453bf3b4d64d11808060.svg";
export { ForwardRef as ReactComponent };